import i18n from '../../i18n.js';

export const DictionaryAttributeTypes = {
  N: {
    id: "N",
    text: i18n.t('dictionary.attributetypes.numeric')
  },
  S: {
    id: "S",
    text: i18n.t('dictionary.attributetypes.string')
  },
  D: {
    id: "D",
    text: i18n.t('dictionary.attributetypes.date')
  },
  F: {
    id: "F",
    text: i18n.t('dictionary.attributetypes.flag')
  }
};

export const dictionaryAttributeTypesDataSourceConfig = {
  store: {
    type: "array",
    data: Object.values(DictionaryAttributeTypes),
    key: "id"
  },
  map: rec => ({ value: rec.id, name: rec.text, ...rec })
}

export const formatDictionaryAttributeTypesText = key =>
  key in DictionaryAttributeTypes ? DictionaryAttributeTypes[key].text : key;
